const LABELS: Record<string, string> = {
  AwaitingPayment: 'Ожидание оплаты',
  Processing: 'Обрабатывается',
  Unconfirmed: 'Не подтверждён',
  WaitCooking: 'Ожидает готовки',
  ReadyForCooking: 'Обрабатывается на кухне',
  CookingStarted: 'Готовится',
  CookingCompleted: 'Приготовлен',
  Waiting: 'Готов к выдаче',
  OnWay: 'В пути',
  Delivered: 'Доставлен',
  Closed: 'Завершён',
  Cancelled: 'Отменён',
};

const TERMINAL = new Set(['Delivered', 'Closed', 'Cancelled']);
const CANCELLABLE = new Set(['AwaitingPayment', 'Processing', 'Unconfirmed', 'WaitCooking']);

export function orderStatusLabel(code: string): string {
  return LABELS[code] ?? code;
}

export function isTerminalOrderStatus(code: string | undefined): boolean {
  if (!code) return false;
  return TERMINAL.has(code);
}

export function isCancellableStatus(code: string | undefined): boolean {
  if (!code) return false;
  return CANCELLABLE.has(code);
}
